import { useCallback, useEffect, useMemo, useRef } from 'react';

/** One repeating timer: `start(tick, ms)` replaces any running one; stops on unmount. */
export const useIntervalTask = () => {
  const timerRef = useRef(null);

  const stop = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const start = useCallback((tick, intervalMs) => {
    stop();
    timerRef.current = setInterval(tick, intervalMs);
  }, [stop]);

  useEffect(() => stop, [stop]);

  return useMemo(() => ({ start, stop }), [start, stop]);
};
